import { Component, OnInit, EventEmitter, Output, Input } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import * as _ from 'lodash';
import { TranslateService } from '@ngx-translate/core';

@Component({
   selector: "mapfre-auditlib-item-form",
   templateUrl: "./item-form.component.html",
   styleUrls: ["./item-form.component.scss"]
})
export class ItemFormComponent implements OnInit {
   _columns;
   constructor(private translateService: TranslateService) { }

   @Input()
   get columns() {
      return this._columns;
   }
   set columns(value) {
      this._columns = value;
   }

   @Output() cancelled = new EventEmitter();
   @Output() updated = new EventEmitter();
   @Output() selectChange = new EventEmitter();
   @Input() form: UntypedFormGroup;
   @Input() nuuma;
   @Input() defaultActions;

   ngOnInit() { }

   onCancelledClicked() {
      this.cancelled.emit(false);
   }

   onSave(form) {
      this.updated.emit(form);
   }

   onSelectChange(event, field) {
      this.selectChange.emit({ event, field });
   }

   getName(name) {
      if (name) {
         return name
      } else {
         return this.nuuma
      }
   }

   getDate(date) {
      if (date) {
         return date
      } else {
         return new Date();
      }
   }
}
